import React from 'react';
import CollectionDiamond from './images/collectionDiamond.svg';
import DropdownIcon from './images/dropdownIcon.svg';

class DropDownSelect extends React.Component {
    constructor(props){
        super(props);
        this.state={
            dropDown: false,
            selectedString: '',
            selectedData: '',
        }
        this.showDropDown = this.showDropDown.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
    }
    showDropDown() {
        var currentState = this.state.dropDown;
        this.setState({dropDown: !currentState});
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    selectItem(event){
        var target = event.target;
        var collectionId = target.attributes[0].value;
        var collectionName = target.innerText;
        
        var itemListDiv = target.parentElement.parentElement;
        var itemList = itemListDiv.querySelectorAll('.dropdown-item');

        itemList.forEach(function(element) {
          element.classList.remove('selected');
        });
        
        target.parentElement.classList.add('selected');
        this.setState({
            selectedString: collectionName,
            selectedData: collectionId
        });
        this.props.itemSelected(collectionId, collectionName);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({dropDown: false});
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    render(){
        let collections = [];

        var collectionUrl = this.props.collectionUrl;

        if(this.props.makeLinks){
            if(this.props.menuItem){
                this.props.menuItem.forEach(element => {
                    collections.push(
                        <a href={`${collectionUrl+element.url}`} key={element.collection_id} className={`dropdown-item-link ${(this.props.className)?this.props.className:''}`}>
                        <div data-item={element.collection_id} className={`dropdown-item ${(element.collection_id === this.props.selectedItemId)?'selected':''}`} onClick={this.selectItem}>
                            <span data-item={element.collection_id} style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{element.collection_name}</span>
                        </div>
                        </a>
                    );
                });
            }
        }else{
           if(this.props.menuItem){
            this.props.menuItem.forEach(element => {
                collections.push(
                    <div data-item={element.collection_id} key={element.collection_id} className={`dropdown-item ${(element.collection_id === this.props.selectedItemId)?'selected':''}`} onClick={this.selectItem}>
                        <span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}} data-item={element.collection_id}>{element.collection_name}</span>
                    </div>
                );
            });
            }
        }
        return (
            <div className={`container-collection-filters dropdown ${this.state.dropDown?'show':''}`} ref={this.setWrapperRef} onClick={this.showDropDown}>
                <div className={`dropdown-icon ${this.props.showRightIcon?'':'hidden'}`} style={{width:'1.5rem'}}>
                    <img src={this.props.leftSideIcon}  style={{display:'block',height:'100%'}} alt=""/>
                </div>
                <div className={`selected-item ${(this.props.className)?this.props.className:''}`}>
                    <div data-item={(this.state.selectedData !== '')?this.state.selectedData:this.props.selectedItemId} className="dropdown-item" style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                        {(this.state.selectedString !== '')?this.state.selectedString:this.props.selectedItem} 
                    </div>
                </div>
                <div className={`dropdown-icon dropdown-arrow ${(this.props.showLeftIcon || collections.length === 0)?'':'hidden'}`}>
                    <img src={this.props.rightSideIcon}  style={{display:'block',height:'100%'}} alt=""/>
                </div>
                <div className="dropdown-menu" style={this.props.style}>
                    <div className="triangle">
                        <span></span>
                    </div>
                    <div className="item-list">
                        {collections}
                    </div>
                </div>
            </div>
        );
    }

}
DropDownSelect.defaultProps = {
    showRightIcon: true,
    showLeftIcon: true,
    rightSideIcon: DropdownIcon,
    leftSideIcon: CollectionDiamond
  };
export default DropDownSelect;


// WEBPACK FOOTER //
// ./src/DropDown.jsx